import { render } from "./service-list-page.vue?vue&type=template&id=3577efac&scoped=true"
import script from "./service-list-page.vue?vue&type=script&lang=js"
export * from "./service-list-page.vue?vue&type=script&lang=js"

import "./service-list-page.vue?vue&type=style&index=0&id=3577efac&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3577efac"]])

export default __exports__